(() => {
  if (customElements.get('bfc-help-center')) return;
  class BfcHelpCenter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const search = this.querySelector('[data-help-search]');
      const reset = this.querySelector('[data-help-reset]');
      const status = this.querySelector('[data-help-status]');
      const empty = this.querySelector('[data-help-empty]');
      const groups = [...this.querySelectorAll('[data-help-group]')];
      const questions = [...this.querySelectorAll('[data-help-question]')];
      const normalize = (value) => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
      const texts = questions.map((question) => normalize(question.textContent));
      const initialOpen = new Set(questions.filter((question) => question.open));
      let searching = false;
      const filter = () => {
        const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
        if (words.length && !searching) {
          initialOpen.clear();
          questions.filter((question) => question.open).forEach((question) => initialOpen.add(question));
        }
        let matches = 0;
        questions.forEach((question, index) => {
          const match = words.every((word) => texts[index].includes(word));
          question.hidden = !match;
          if (words.length) question.open = match;
          else if (searching) question.open = initialOpen.has(question);
          if (match) matches += 1;
        });
        groups.forEach((group) => { group.hidden = ![...group.querySelectorAll('[data-help-question]')].some((question) => !question.hidden); });
        searching = words.length > 0;
        reset.hidden = !searching;
        status.hidden = !searching;
        status.textContent = matches === 1 ? '1 passende Antwort' : `${matches} passende Antworten`;
        empty.hidden = matches > 0;
      };
      this.querySelector('[data-help-search-wrap]').hidden = false;
      search.addEventListener('input', filter);
      reset.addEventListener('click', () => { search.value = ''; filter(); search.focus(); });
      this.querySelectorAll('[data-help-topic]').forEach((link) => link.addEventListener('click', () => {
        search.value = '';
        filter();
        const heading = this.querySelector(`${link.getAttribute('href')} h2`);
        if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
      }));
      const contactStatus = this.querySelector('[data-contact-status]');
      if (!contactStatus) {
        const topicPresets = new Map([['abo', 'Futter-Abo'], ['vorverkauf', 'Vorbestellung & Versand']]);
        const preset = topicPresets.get(new URLSearchParams(window.location.search).get('thema'));
        const subject = this.querySelector('select[name="contact[Thema]"]');
        if (preset && subject) subject.value = preset;
      }
      if (contactStatus && /contact_posted|contact_form/.test(window.location.search + window.location.hash)) contactStatus.focus();
    }
  }
  customElements.define('bfc-help-center', BfcHelpCenter);
})();
